module.exports = __webpack_public_path__ + "assets/images/match-field-sponsor-heineken.5a1d778df49e25ac82c8d7b5b576a1de.png";